// --------------------------------------------------------------
// Created On: 2026-10-26
// Author: Zachary Thomas
//
// Last Modified: 2026-10-26
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// The names of all variables that are used for local storage.

// Authentication and session state persisted by the redux slices. The mobile app also writes these keys directly.
export const LOCAL_STORAGE_ID_TOKEN_KEY = "reduxIdToken";
export const LOCAL_STORAGE_LEGACY_AUTHORIZER_TOKEN_KEY = "reduxAuthorizerToken";
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = "reduxAccessToken";
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = "reduxRefreshToken";
export const LOCAL_STORAGE_SESSION_TOKEN_KEY = "reduxSessionToken";
export const LOCAL_STORAGE_CURRENT_USER_KEY = "reduxCurrentUser";
export const LOCAL_STORAGE_NEW_PASSWORD_REQUIRED_KEY = "reduxNewPasswordRequired";
export const LOCAL_STORAGE_MFA_CHALLENGE_REQUIRED_KEY = "reduxMfaChallengeRequired";
export const LOCAL_STORAGE_MFA_SETUP_REQUIRED_KEY = "reduxMfaSetupRequired";

// User interface preferences and selections.
export const LOCAL_STORAGE_DEVICE_ATTRIBUTES_KEY = "reduxDeviceAttributes";
export const LOCAL_STORAGE_AXIS_MODE_KEY = "axisMode";
export const LOCAL_STORAGE_ASSET_LIST_DISPLAY_KEY = "assetListDisplay";
export const LOCAL_STORAGE_SELECTED_ASSETGROUP_ID_KEY = "selectedAssetgroupId";
export const LOCAL_STORAGE_SELECTED_VIEW_ID_KEY = "selectedViewId";
export const LOCAL_STORAGE_SELECTED_DASHBOARD_KEY = "selectedDashboard";
export const LOCAL_STORAGE_DISABLE_DASHBOARD_INACTIVE_CHECK_KEY = "disableDashboardInactiveCheck";
